import { render, staticRenderFns } from "./ParcelTimes.vue?vue&type=template&id=bc703428&"
import script from "./ParcelTimes.vue?vue&type=script&lang=js&"
export * from "./ParcelTimes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports